import { createSlice } from "@reduxjs/toolkit";
import { StoriesAPI } from "../../services/stories";

const Stories = createSlice({
  name: "stories",
  initialState: {
    list: [],
    oneStory: null,
    total: 0,
  },
  reducers: {
    clearOneStory: (state) => {
      state.oneStory = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(StoriesAPI.getAll.fulfilled, (state, action) => {
        const { total, stories } = action.payload;
        state.list = stories;
        state.total = total;
      })
      .addCase(StoriesAPI.getOne.fulfilled, (state, action) => {
        state.oneStory = action.payload;
      });
  },
});

export const { clearOneStory } = Stories.actions;
export default Stories;
